import { render, staticRenderFns } from "./JumpType.vue?vue&type=template&id=29f50e20&scoped=true"
import script from "./JumpType.vue?vue&type=script&lang=ts"
export * from "./JumpType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f50e20",
  null
  
)

export default component.exports